module.exports = __webpack_public_path__ + "img/apiLoader.a242b098.gif";